import React, { useEffect } from 'react';

import { useAPIDesignerStore, type APIv2ReferencePayload } from '.';

interface InitializeAPIDesignerStoreProps {
  apiObject?: APIv2ReferencePayload;
  children: React.ReactNode;
}

export function InitializeAPIDesignerStore({ children, apiObject }: InitializeAPIDesignerStoreProps) {
  const [isReady, initialize] = useAPIDesignerStore(s => [s.isReady, s.initialize]);

  if (!isReady && apiObject) {
    initialize({ apiObject });
  }

  useEffect(() => {
    if (apiObject) {
      initialize({ apiObject });
    }
  }, [initialize, apiObject]);

  return <>{children}</>;
}
